
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import UtilsFormule from "../../utils/UtilsFormule";
import { Snackbar, TextField } from "@material-ui/core";
import OrderService from "../../services/PosService/OrderService";
import withLoader from "../../components/layouts/WithLoader";
import DataTableTicketCredit from "../../ui/DataTableTicketCredit";
import DataTableTraitesShop from "../../ui/DataTableTraitesShop";
const TraiteShop = ({ startLoading, stopLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [availableTicket, setAvailableTicket] = useState([]);
 
  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [alertMessage, setAlertMessage] = useState("");
  //statistique
  const [titleFilter, setTitleFilter] = useState("Recherche par date de paiement");


  //payement total card
 
  //btnClear
  const [btnClear, setBtnClear] = useState(false);

  useEffect(() => {
    onGetTickets();
  }, []);

  const onGetTickets = () => {
    startLoading();
          setTitleFilter("Recherche par date de paiement")

    OrderService.getAllPayementsTraitesShop(
      localStorage.getItem("idDetailsTicketMagasin"),
      dateBegin !== "any" ? dateBegin.concat("T00:00:00") : "any",
      dateEnd !== "any" ? dateEnd.concat("T23:59:59") : "any"
    )
      .then((response) => {
        if (response?.data?.success) {
          setAvailableTicket(response?.data?.success);
        
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };


    const onGetTicketsEcheance = () => {
      setTitleFilter("Recherche par date d'echeance")
    startLoading();
    setAvailableTicket([])
    OrderService.getAllPayementsTraitesShopDateEcheance(
      localStorage.getItem("idDetailsTicketMagasin"),
      dateBegin !== "any" ? dateBegin.concat("T00:00:00") : "any",
      dateEnd !== "any" ? dateEnd.concat("T23:59:59") : "any"
    )
      .then((response) => {
        if (response?.data?.success) {
          setAvailableTicket(response?.data?.success);
        
        }
      })
      .catch((error) => {
        setAlertMessage("error " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };

 
  const onGetTicketsByFiltersHandler = () => {
    onGetTickets();
    // setBtnClear(true);
  };
 const onGetTicketsEcheanceByFiltersHandler = () => {
    onGetTicketsEcheance();
    // setBtnClear(true);
  };

  const onChangeDateBegin = (event) => {
    setDateBegin(event.target.value);
  };

  const onChangeDateEnd = (event) => {
    setDateEnd(event.target.value);
  };

  const filterTableTicket = () => {
    if (availableTicket && availableTicket?.length > 0) {
      return <DataTableTraitesShop title={titleFilter} tickets={availableTicket} />;
    }
  };
 

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
     
      <section className="content-header">
        <div className="container-fluid">
          <div class="card card-dark">
            <div class="card-body">
              <h5 class="card-title">Les Credits du magasin {localStorage.getItem("nameDetailsTicketMagasin")}</h5>
             
              <br />
              <div className="row">
                <p>
                  <small>
                    Initialement, il y avait des tickets pour ce jour{" "}
                    <b>{UtilsFormule.formatDate(new Date())}</b>.
                  </small>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="content ">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">
              <div class="card card-dark">
                <div class="card-body">
                  <div class="row">
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date début</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateBegin}
                          onChange={onChangeDateBegin}
                          id="date"
                          // label="Date Début"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="form-group">
                        <label htmlFor="inputName">Date fin</label>

                        <TextField
                          style={{ width: "100%" }}
                          className="col-sm-12"
                          variant="outlined"
                          value={dateEnd}
                          onChange={onChangeDateEnd}
                          id="date"
                          // label="Date fin"
                          type="date"
                          defaultValue="date"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          size="small"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="row">
                   
                    <div className="col-sm-6 text-center">
                    <div
                      className={
                        !btnClear
                          ? "col-sm-12 text-center"
                          : "col-sm-6 text-center"
                      }
                    >
                      <button
                        className="btn btn-dark"
                        onClick={onGetTicketsEcheanceByFiltersHandler}
                      >
                        Chercher par date d'echeance
                      </button>
                    </div>
                    </div>
                    <div className="col-sm-6 text-center">
                    <div
                      className={
                        !btnClear
                          ? "col-sm-12 text-center"
                          : "col-sm-6 text-center"
                      }
                    >
                      <button
                        className="btn btn-dark"
                        onClick={onGetTicketsByFiltersHandler}
                      >
                        Chercher par date de paiement
                      </button>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    


      <section class="content">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-12">{filterTableTicket()}</div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default withLoader(TraiteShop);
